//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function () {
    return {};
  },

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    message: function () {
      return this.$store.state['send-quest-notification']?.senQuestNotificationMessage;
    },
    type: function () {
      return this.$store.state['send-quest-notification']?.senQuestNotificationType || '';
    },
    buttonCloseLink: function () {
      return this.$store.state['send-quest-notification']?.senQuestNotificationParams?.buttonLink || "";
    },
    buttonCloseText: function () {
      return this.$store.state['send-quest-notification']?.senQuestNotificationParams?.buttonText || "Закрыть";
    },

    buttonCloseComponent: function () {
      if (this.buttonCloseLink) {
        return "nuxt-link"
      }
      return "button"
    }
  },

  methods: {

    close: function () {
      this.$store.commit(
        "send-quest-notification/closeSendQuestNotification",
        {
          message: '',
          params: {
            type: "info"
          }
        }
      )
    }

  }
};
